import React from "react";
import styles from "./index.module.scss";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import { DelegateContext } from "@/types/modular-permissions.types";
import classNames from "classnames";

type Props = {};

const PermissionContextSwitch = (props: Props) => {
  const {
    activeDelegateContext,
    setActiveDelegateContext,
    cancelDelegateCreation,
  } = useModularPermissionsStore();

  function handleSwitch(context: DelegateContext) {
    cancelDelegateCreation();
    setActiveDelegateContext(context);
  }

  return (
    <div className={styles.switchContainer}>
      <button
        className={classNames(
          activeDelegateContext === DelegateContext.Granted && styles.active,
        )}
        onClick={() => handleSwitch(DelegateContext.Granted)}
      >
        Granted Permissions
      </button>
      <button
        className={classNames(
          activeDelegateContext === DelegateContext.Received && styles.active,
        )}
        onClick={() => handleSwitch(DelegateContext.Received)}
      >
        Received Permissions
      </button>
    </div>
  );
};

export default PermissionContextSwitch;
